export default __webpack_public_path__ + "static/media/icons8-close.5084f146.svg";